module.exports = __webpack_public_path__ + "img/searchbtn.ef2712d0.png";